import LeaderProfile from './Leader_Profile/LeaderProfile.jsx';
import { president } from './Leader_Profile/LeaderProfile.js';

const Secretary = () => {
  return (
    <LeaderProfile
      name={president.name}
      education={president.education}
      majorActivities={president.majorActivities}
      collegeIntro={president.collegeIntro}
      image={president.image}
      designation={president.designation}
    />
  )
}

export default Secretary
